// Mount path for the public Endkunde share form. Kept in its own tiny module so the endkunde
// bootstrap path (bootstrap.ts) can read it WITHOUT importing app.routes — which would pull in
// Keycloak, pilot and the rest of the normal-app providers the anonymous customer must not load.
// Lowercased by LowerCaseUrlSerializer, so the mount must be lowercase; the customer's link
// (…/endkundeFormular/<guid>) still resolves.
export const ENDKUNDE_MOUNT_PATH = 'endkundeformular';
